import { Action } from "../components/Actions";
import { EditorialShell } from "../components/EditorialShell";
import { RadarFigure } from "../components/RadarFigure";
import { DIMENSION_DESCRIPTIONS, displayDimension, sortedDimensions, toDisplayCopy } from "../logic/dimensions";
import type { OfficialResult } from "../types";

export function OfficialResultHeroScreen({ result, onViewSongs, onCreateCard, onRestart }: {
  result: OfficialResult;
  onViewSongs(): void;
  onCreateCard(): void;
  onRestart(): void;
}) {
  const topDimensions = sortedDimensions(result.classification.percentiles).slice(0, 3);
  return (
    <EditorialShell className="persona-result-page">
      <section className="persona-result-layout result-page-enter" aria-labelledby="official-persona-title">
        <div className="persona-result-copy">
          <p className="result-label">你的 WMLS 人格</p>
          <h1 id="official-persona-title" className="persona-result-title">{toDisplayCopy(result.persona.title)}</h1>
          <p className="result-judgement">{toDisplayCopy(result.persona.judgement)}</p>
          {result.persona.body ? (
            <div className="result-core-copy">
              {result.persona.body.split(/\n{2,}/).map((paragraph) => <p key={paragraph}>{toDisplayCopy(paragraph)}</p>)}
            </div>
          ) : null}
        </div>

        <div className="persona-result-mark">
          <RadarFigure values={result.classification.percentiles} />
          <div className="result-core-notes" aria-label="最突出的三种倾向">
            {topDimensions.map((dimension) => (
              <p key={dimension}><strong>{displayDimension(dimension)}</strong>{DIMENSION_DESCRIPTIONS[dimension]}</p>
            ))}
          </div>
        </div>

        <div className="persona-result-actions">
          <Action onClick={onViewSongs}>看看我的九首歌</Action>
          <Action tone="secondary" onClick={onCreateCard}>生成结果卡片</Action>
          <Action tone="text" onClick={onRestart}>重新测试</Action>
        </div>
      </section>
    </EditorialShell>
  );
}
